<template>
  <div class="container mt-3" v-if="!noticeLoading">
    <div class="mt-3">
      <h3 class="title mb-3">공지사항 > 수정</h3>
    </div>

    <Form @submit="onSubmit" :initial-values="noticeInitValues" ref="modifyNoticeForm" class="form">
      <b-row class="mb-4">
        <b-col cols="2">
          <div class="mb-1">
            <label for="contentsType">공지 <span class="required">*</span></label>
          </div>
          <Field id="contentsType" v-model="noticeInitValues.contentsType" name="contentsType" label="공지" rules="required" v-slot="{ field, errors }">
            <b-form-select v-bind="field" v-model="noticeInitValues.contentsType" :options="contentsTypeList" :state="errors[0] ? false : null"></b-form-select>
          </Field>
        </b-col>
        <b-col cols="10">
          <div class="mb-1">
            <label for="name">제목 <span class="required">*</span></label>
          </div>
          <Field id="title" v-model="noticeInitValues.title" name="title" label="제목" rules="required" v-slot="{ field, errors }">
            <b-form-input id="title" v-model="noticeInitValues.title" name="title" type="text" v-bind="field" placeholder="제목을 입력하세요" :state="errors[0] ? false : null">
            </b-form-input>
          </Field>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <Field ref="contentsRef" id="contents" name="contents" label="공지내용" v-model="noticeInitValues.contents" v-slot="{ field, errors }" rules="required">
            <TinyEditor :id="`contents${sugangIdx}`" :editData="noticeInitValues.contents" :error="errors[0]" @change="onChangeEditor"></TinyEditor>
            <input type="hidden" v-bind="field" />
          </Field>
        </b-col>
      </b-row>

      <div class="txt-right mt-3">
        <div class="d-flex justify-content-end">
          <b-button variant="primary" class="search-button me-2" @click="back">돌아가기</b-button>
          <b-button variant="danger" class="search-button me-2" @click="deleteBoard">삭제</b-button>
          <b-button variant="primary" class="search-button" :disabled="btnLoading ? true : false" @click="onSubmit">등록</b-button>
        </div>
      </div>
    </Form>
  </div>
  <h1 class="center" v-else>
    <Loading v-if="noticeLoading"></Loading>
  </h1>
</template>

<script>
import { reactive, ref } from '@vue/reactivity';
import { onMounted } from '@vue/runtime-core';
import { useRoute, useRouter } from 'vue-router';
import { sugangNoticeDetailApi, sugangNoticeModifyApi, sugangNoticeDeleteApi } from '@/api/integrateapi/index';
export default {
  setup() {
    const modifyNoticeForm = ref(null);
    const noticeLoading = ref(false);
    const contentsRef = ref(false);
    const route = useRoute();
    const router = useRouter();
    const sugangIdx = ref(-1);
    const boardIdx = ref(-1);
    const noticeInitValues = {
      contentsType: 'none',
      title: '',
      contents: '',
    };
    const contentsTypeList = reactive([
      { value: 'none', text: '해당없음' },
      { value: 'overall ', text: '전체공지' },
      { value: 'plural', text: '복수과정' },
    ]);

    const btnLoading = ref(false);

    const onChangeEditor = data => {
      const { validate } = contentsRef.value;
      noticeInitValues.contents = data.contents;
      validate();
    };

    const onSubmit = async () => {
      const { validate } = modifyNoticeForm.value;
      const { valid } = await validate();
      if (!valid) {
        alert('필수 값을 확인해주세요.');
        return false;
      }

      modifyNotice();
    };

    const getNoticeInfo = () => {
      noticeLoading.value = true;
      sugangNoticeDetailApi(sugangIdx.value, boardIdx.value)
        .then(resp => {
          const { success, data: respData } = resp.data;
          if (success) {
            noticeInitValues.title = respData['title'];
            noticeInitValues.contentsType = respData['contentsType'];
            noticeInitValues.contents = respData['contents'];
          } else {
            noticeInitValues.title = '';
            noticeInitValues.contentsType = '';
            noticeInitValues.contents = '';
          }
        })

        .catch(error => {
          if (error.response) {
            // 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else if (error.request) {
            // 요청이 이루어 졌으나 응답을 받지 못했습니다.
            // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
            // Node.js의 http.ClientRequest 인스턴스입니다.
            console.log(error.request);
          } else {
            // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
            console.log('Error', error.message);
          }
          console.log(error.config);
        })
        .finally(() => {
          noticeLoading.value = false;
        });
    };

    const modifyNotice = () => {
      btnLoading.value = true;
      sugangNoticeModifyApi(sugangIdx.value, boardIdx.value, noticeInitValues)
        .then(resp => {
          const { success } = resp.data;
          if (success) {
            alert('저장되었습니다.');
            router.back();
          } else {
            alert('저장에 실패하였습니다.');
          }
        })
        .catch(error => {
          if (error.response) {
            alert('서버에 에러가 발생하였습니다.');
            // 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else if (error.request) {
            // 요청이 이루어 졌으나 응답을 받지 못했습니다.
            // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
            // Node.js의 http.ClientRequest 인스턴스입니다.
            console.log(error.request);
          } else {
            // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
            console.log('Error', error.message);
          }
          console.log(error.config);
        })
        .finally(() => {
          btnLoading.value = false;
        });
    };

    const back = () => {
      router.back();
    };
    const deleteBoard = () => {
      if (!window.confirm('정말 삭제하시겠습니까?')) {
        return;
      }
      sugangNoticeDeleteApi(router.currentRoute.value.query.sugangIdx, [{ idx: router.currentRoute.value.query.idx }])
        .then(resp => {
          const { success } = resp.data;
          if (success) {
            alert('삭제 되었습니다.');
            router.back();
          } else {
            alert('삭제에 실패하였습니다.');
          }
        })
        .catch(error => {
          if (error.response) {
            alert('서버에 에러가 발생하였습니다.');
            // 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else if (error.request) {
            // 요청이 이루어 졌으나 응답을 받지 못했습니다.
            // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
            // Node.js의 http.ClientRequest 인스턴스입니다.
            console.log(error.request);
          } else {
            // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
            console.log('Error', error.message);
          }
          console.log(error.config);
        })
        .finally(() => {});
    };
    onMounted(() => {
      const { boardIdx: brdIdx } = route.params;
      const { sugangIdx: sgIdx } = route.query;

      boardIdx.value = Number(brdIdx);
      sugangIdx.value = Number(sgIdx);

      getNoticeInfo();
    });

    return {
      modifyNoticeForm,
      contentsRef,
      noticeInitValues,
      contentsTypeList,
      onChangeEditor,
      boardIdx,
      sugangIdx,
      noticeLoading,
      onSubmit,
      btnLoading,
      back,
      deleteBoard,
    };
  },
};
</script>

<style></style>
